import { IGenericBaryFormGroup } from './GenericBaryFormGroup';
import { FormControl, FormGroup } from '@angular/forms';
import { FormGroupHelper } from './FormGroupHelper';
import { AddressFormGroup } from './AddressFormGroup';
import { ContactControls } from './builder/ContactFormBuilder';
import { User } from '../user.model';
import { IRegisteredAddress } from '../registered-address.model';
import { RegisteredAddressMapper } from '../../app/shared/mapper/registered-address-mapper';
import { patchObject } from '../../app/shared/util/object-util';
import { AddressTypeEnum } from '../enums/address-type.enum';

export type RegisteredAddressControls = {
  alias: FormControl;
  addressType: FormControl;
  contact: IGenericBaryFormGroup<ContactControls>;
  address: AddressFormGroup;
  loadingConstraint: FormControl;
  accessConstraint: FormControl;
  cityCode: FormControl;
};

export class RegisteredAddressFormGroup extends FormGroupHelper implements IGenericBaryFormGroup<RegisteredAddressControls> {
  protected declare form: FormGroup;
  private user: User;
  name = 'registeredAddressForm';
  updated = false;
  controls: RegisteredAddressControls;

  constructor(formName: string, controls: RegisteredAddressControls, user: User) {
    super();
    this.name = formName;
    this.form = this.newFormGroup(controls);
    this.controls = controls;
    this.user = user;
  }

  value(): any {
    return this.form.value;
  }

  getAngularForm(): FormGroup {
    return this.form;
  }

  updateForm(model: IRegisteredAddress): void {
    this.controls.addressType.setValue(RegisteredAddressMapper.getAddressType(model));
    this.controls.address.updateForm(RegisteredAddressMapper.getAddress(model));
    this.controls.contact.updateForm(RegisteredAddressMapper.getContact(model));
    this.controls.alias.setValue(model.alias);
    this.controls.accessConstraint.setValue(model.accessConstraint);
    this.controls.loadingConstraint.setValue(model.loadingConstraint);
    this.controls.cityCode.setValue(model.cityCode);

    this.updated = true;
  }

  updateModel(model: IRegisteredAddress): void {
    patchObject(model, this.value());
    patchObject(model, this.controls.address.value());
    RegisteredAddressMapper.updateContactRegisteredAddress(model, this.controls.contact.value());
    this.setAddressType(model);
  }

  setAddressType(model: IRegisteredAddress): void {
    if (this.controls.addressType.value === AddressTypeEnum.BOTH) {
      model.pickupUser = this.user;
      model.deliveryUser = this.user;
    } else if (this.controls.addressType.value === AddressTypeEnum.PICKUP) {
      model.pickupUser = this.user;
      model.deliveryUser = undefined;
    } else {
      model.pickupUser = undefined;
      model.deliveryUser = this.user;
    }
  }
}
